var scope_0 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/513f836e393c30eadd0715fecfdafdd6.js').default;
var scope_1 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/550bb8385ad1f1193c11abd612dc89dd.js').default;
var scope_2 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/7d2c2830f6c1602ee0156d4112da33e0.js').default;
var scope_3 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/937234e738f3ad193a31ad9b53db4f29.js').default;
var scope_4 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/a034b6c873c84d58f7d591f7b3e3c03a.js').default;
var scope_5 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b18e73b095fe7296c3f4203054b37562.js').default;
var scope_6 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b54bfa5bf13ef1e1bfe9a3345b7d00c4.js').default;
var scope_7 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/b87c5ecf13389953dca7a1dd91aaa6bb.js').default;
var scope_8 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/c3bbdae8df3f32e8996bc0bdd5d43312.js').default;
var scope_9 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/d7534d2b437e0172e280fbfcee3ffce9.js').default;
var scope_10 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e8b5db6d0f97477f855dda39fe49d590.js').default;
var scope_11 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/e92f8988d65cf25c087d226e6c0ef06f.js').default;
var scope_12 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/ebd19db30c207011605f26cc8799219e.js').default;
var scope_13 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f0d93ad2d6ef68934614c500a96b9f06.js').default;
var scope_14 = require('C:/Source Control/nebula-design-system/.cache/caches/gatsby-plugin-mdx/mdx-scopes-dir/f108d1161f92f234ca905d44ee8c3b9f.js').default;export default
        Object.assign({}, scope_0,
scope_1,
scope_2,
scope_3,
scope_4,
scope_5,
scope_6,
scope_7,
scope_8,
scope_9,
scope_10,
scope_11,
scope_12,
scope_13,
scope_14 )
    